import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li
                app-menuitem
                *ngIf="!item.separator"
                [item]="item"
                [index]="i"
                [root]="true"
            ></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `,
})
export class AppMenu {
    model: any[] = [];

    ngOnInit() {
        this.model = [
            { label: 'Dashboard', icon: 'pi pi-home', routerLink: ['/dashboard'] },
            {
                label: 'Booking Ops',
                icon: 'pi pi-fw pi-calendar',
                items: [
                    { label: 'Reserve List', icon: 'pi pi-fw pi-list', routerLink: ['/reserve'] },
                    { label: 'Cancel / Refund Queue', icon: 'pi pi-fw pi-times-circle', routerLink: ['/reserve/cancelled'] }
                ]
            },
            {
                label: 'Inventory',
                icon: 'pi pi-fw pi-clock',
                items: [
                    { label: 'Slot Manager', icon: 'pi pi-fw pi-list', routerLink: ['/slot'] },
                    { label: 'Price Rule Manager', icon: 'pi pi-fw pi-list', routerLink: ['/price-rule'] },
                    { label: 'Calendar', icon: 'pi pi-fw pi-calendar', routerLink: ['/price-rule/calendar'] },
                    { label: 'Holiday', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/price-rule/holiday'] },
                    { label: 'Course Remark', icon: 'pi pi-fw pi-comments', routerLink: ['/price-rule/course-remark'] },
                    { label: 'Slot Action Logs', icon: 'pi pi-fw pi-history', routerLink: ['/slot/action-log'] }
                ]
            },
            {
                label: 'Monitoring',
                icon: 'pi pi-fw pi-chart-line',
                items: [
                    { label: 'Sales Monitor', icon: 'pi pi-fw pi-chart-line', routerLink: ['/sales-monitor'] },
                    { label: 'Slot Overview', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/slot/overview'] },
                    { label: 'Course Price', icon: 'pi pi-fw pi-wallet', routerLink: ['/slot/course-price'] },
                    { label: 'Hotdeal Overview', icon: 'pi pi-fw pi-bolt', routerLink: ['/slot/hotdeal-overview'] },
                    { label: 'Price Overview', icon: 'pi pi-fw pi-money-bill', routerLink: ['/price-rule/overview'] },
                    { label: 'Sales Targets', icon: 'pi pi-fw pi-bullseye', routerLink: ['/course-sales-target'] },
                    { label: 'Monitoring Zones', icon: 'pi pi-fw pi-sitemap', routerLink: ['/monitoring-zone'] },
                    { label: 'Slot Monitor Rule', icon: 'pi pi-fw pi-sliders-h', routerLink: ['/slot/monitor-rule'] }
                ]
            },
            {
                label: 'Marketing',
                icon: 'pi pi-fw pi-megaphone',
                items: [
                    { label: 'Voucher List', icon: 'pi pi-fw pi-ticket', routerLink: ['/voucher'] },
                    { label: 'Voucher Template', icon: 'pi pi-fw pi-file-edit', routerLink: ['/voucher/template'] },
                    { label: 'Reward', icon: 'pi pi-fw pi-gift', routerLink: ['/rewards'] },
                    { label: 'Inbox', icon: 'pi pi-fw pi-inbox', routerLink: ['/inbox/inbox-list'] },
                    { label: 'Private Inbox', icon: 'pi pi-fw pi-envelope', routerLink: ['/inbox/inbox-private-list'] },
                    { label: 'Inbox Template', icon: 'pi pi-fw pi-file-edit', routerLink: ['/inbox/inbox-template'] }
                ]
            },
            {
                label: 'Agent',
                icon: 'pi pi-fw pi-id-card',
                items: [
                    { label: 'Agents', icon: 'pi pi-fw pi-id-card', routerLink: ['/agents'] },
                    { label: 'Bookings', icon: 'pi pi-fw pi-calendar', routerLink: ['/agents/bookings'] },
                    { label: 'Webhook Deliveries', icon: 'pi pi-fw pi-send', routerLink: ['/agents/webhook-deliveries'] },
                    { label: 'Integration', icon: 'pi pi-fw pi-link', routerLink: ['/agents/integration'] }
                ]
            },
            {
                label: 'Settlement',
                icon: 'pi pi-fw pi-wallet',
                items: [
                    { label: 'Transactions', icon: 'pi pi-fw pi-money-bill', routerLink: ['/transfers'] },
                    { label: 'Cost Recovery', icon: 'pi pi-fw pi-refresh', routerLink: ['/transfers/refund-pending'] },
                    { label: 'Coupons', icon: 'pi pi-fw pi-ticket', routerLink: ['/coupon'] },
                    { label: 'Credits', icon: 'pi pi-fw pi-credit-card', routerLink: ['/reserves/course-credit-management'] }
                ]
            },
            {
                label: 'Course Setup',
                icon: 'pi pi-fw pi-map',
                items: [
                    { label: 'Course List', icon: 'pi pi-fw pi-list', routerLink: ['/course'] },
                    { label: 'Area', icon: 'pi pi-fw pi-map-marker', routerLink: ['/course/areas'] },
                    { label: 'Icon', icon: 'pi pi-fw pi-sun', routerLink: ['/course/icons'] },
                    { label: 'Tag', icon: 'pi pi-fw pi-tags', routerLink: ['/course/tags'] }
                ]
            },
            {
                label: 'Admin',
                icon: 'pi pi-fw pi-cog',
                items: [
                    { label: 'Users', icon: 'pi pi-fw pi-users', routerLink: ['/user'] },
                    { label: 'Portal', icon: 'pi pi-fw pi-briefcase', routerLink: ['/portal/partner-login'] },
                    { label: 'Audit', icon: 'pi pi-fw pi-history', routerLink: ['/audit'] },
                    { label: 'Price Rule Audit', icon: 'pi pi-fw pi-tags', routerLink: ['/audit/price-rule'] }
                ]
            }
        ];
    }
}
